<template>
    <v-dialog
        v-model="display"
        persistent
        width="350">
        <v-card>
            <v-card-title>{{ title }}</v-card-title>
            <v-card-text><span v-html="content"></span></v-card-text>
            <v-card-actions>
                <v-btn :loading="loading" text @click="submit">{{ $t('btn_confirm') }}</v-btn>
                <v-btn text @click="close">{{ $t('cancel_btn') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "DecisionDialog",
    data() {
        return {
            display: false,
            target: null,
            id: null,
            title: null,
            content: null,
            payload: null,
            loading: false
        }
    },
    methods: {
        open(params) {
            this.target = params.target;
            this.title = params.title ? params.title : this.$t('confirm_title');
            this.content = params.content;
            this.id = params.id ? params.id : null ;
            this.payload = params.payload;
            this.display = true;
        },
        close() {
            this.$emit('close')
            this.display = false;
            this.target = null;
            this.title = null;
            this.content = null;
            this.id = null;
            this.payload = null;
            this.loading = false;
            this.$emit('close');
        },
        submit() {
            this.$emit("submit", {target: this.target, id: this.id, payload: this.payload});
            this.close();
        }
    },
    created() {
        
    }
}
</script>